// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1ar-D","content":"RecentSearches_content__bZ_Vw"};